<template>
  <div class="flex flex-col items-center">
    <template
      v-for="sector in entranceSectors"
      :key="`sector-${sector.id}`"
    >
      <div class="flex w-full items-center py-5 last:border-b-0 md:border-b md:border-dashed">
        <div class="grow md:text-2xl md:font-bold">
          {{ sector.name }}
        </div>
        <div class="basis-4/12 md:text-2xl">
          {{ sector.prices?.[0] }}
          <span class="font-tenge">a</span>
        </div>
        <GeneralAdmissionSelector
          :sector="sector"
          class="basis-2/12"
          @added="$emit('booking:finished', { action: 'added' })"
          @removed="$emit('booking:finished', { action: 'removed' })"
        />
      </div>
    </template>
  </div>
</template>

<script setup>
import { useApp } from '@/Front/Stores/useApp.js';
import GeneralAdmissionSelector from '@/Front/Views/Events/GeneralAdmissionSelector.vue';

defineEmits(['booking:finished']);

const appStore = useApp();
const entranceSectors = appStore.entranceSectors.filter((sector) => sector.quantity > 0);
</script>
